// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__kWNmw","error":"Textarea_error__211Wp","readonly":"Textarea_readonly__1jZQG","disabled":"Textarea_disabled__VbcRf"};